import React, { forwardRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const toolbarOptions = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ align: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }],
    [{ direction: 'rtl' }],
    ['link', 'image'],
    ['clean'],
  ],
};

export interface IRichTextEditor {
  value: string;
  height: number;
  onChange: (content: string) => void;
}

const RichTextEditor = forwardRef<any, IRichTextEditor>((props, ref) => {
  return (
    <div style={{ height: `${props.height}px` }}>
      <ReactQuill
        ref={ref}
        theme='snow'
        style={{ height: `${props.height - 50}px` }}
        value={props.value ?? ''}
        onChange={(content) => props.onChange(content)}
        modules={toolbarOptions}
      />
    </div>
  );
});

export default RichTextEditor;
